// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footerContent":"Footer_footerContent__aHfIE","col1":"Footer_col1__3kzE6","authors":"Footer_authors__29AON","copyright":"Footer_copyright__2OWH4"};